module.exports = "<div class=\"ot-info\"\n  ng-class=\"{'ot-horizontal': params.type == 'horizontal', 'ot-vertical': params.type == 'vertical'}\">\n  <p ng-repeat=\"item in vm.getData().items\" ng-class=\"item.class\" ng-if=\"item.visible\">\n    <span ng-if=\"!$parent.params.onlyText\" ng-class=\"item.icon\"></span>\n    <span>{{item.text}}</span>\n  </p>\n</div>\n"


/*****************
 ** WEBPACK FOOTER
 ** ./src/templates/directives/content/info.html
 ** module id = 266
 ** module chunks = 1
 **/